export const bodyTitle = 'Create a profile';
export const serverError = 'Server Error';
